import type { Router } from 'vue-router'
import { ElNotification } from 'element-plus'
import { setSessionExpiredHandler } from '@/axios'
import i18n from '@/i18n'

export function initializeSessionRecovery(router: Router, user: { clearLocalSession(): void }): void {
  setSessionExpiredHandler(() => {
    user.clearLocalSession()
    ElNotification.warning(i18n.global.t('session_expired'))
    // The initial /me check can fail inside a navigation guard. Do not start a
    // second navigation until that initial navigation has settled.
    void router.isReady().then(() => {
      if (!localStorage.getItem('token') && router.currentRoute.value.name !== 'login') {
        return router.replace({ name: 'login' })
      }
    }).catch(() => undefined)
  })
}
